<template>
  <v-card flat>
    <v-tabs v-model="tab" grow>
      <v-tab>پرداخت معمولی</v-tab>
      <v-tab>پرداخت سرور</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card :loading="loading" class="p-3 pt-0" flat>
          <v-btn class="btn-report text-right" @click="cafeBazarList = true">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            کافه بازار
          </v-btn>

          <!--              <v-btn class="btn-report text-right" @click="cafeBazarList = true">-->
          <!--                <span class="fa fa-list ml-1"></span>-->
          <!--                تراکنش کافه بازار-->
          <!--              </v-btn>-->

          <!--              <v-btn class="btn-charge-wallet text-right" @click="openCafeCharge = true">-->
          <!--                <span class="fa fa-dollar-sign ml-1"></span>-->
          <!--                شارژ کافه بازار-->
          <!--              </v-btn>-->

          <!--              <custom-popup v-model="openCafeCharge" :cons="cons" hide-confirm hide-overlay max-width="600">-->
          <!--                <v-row class="pa-2" no-gutters>-->
          <!--                  <v-col class="pa-2" cols="12">-->
          <!--                    <price-input v-model="cafeChargeAmount" dense="" label="مبلغ"/>-->
          <!--                  </v-col>-->
          <!--                </v-row>-->

          <!--                <v-card-actions>-->
          <!--                  <v-btn :disabled="!cafeChargeAmount" class="btn-charge-wallet text-right" @click="cafeCharge">-->
          <!--                    <span class="fa fa-dollar-sign ml-1"></span>-->
          <!--                    شارژ کافه بازار-->
          <!--                  </v-btn>-->
          <!--                </v-card-actions>-->
          <!--              </custom-popup>-->

          <vue-table
            v-model="selectedRows"
            :data="data"
            :headers="headers"
            :loading.sync="loading"
            show-select
            @change="onPagination"
          >
            <template v-slot:filters="{ perPage, props }">
              <v-row no-gutters>
                <v-col class="pa-2" cols="12" lg="1" md="2">
                  <v-select
                    v-model="props.length"
                    :items="perPage"
                    class="rounded-lg"
                    dense
                    label="تعداد"
                    outlined
                  />
                </v-col>

                <v-col class="pa-2" cols="12" lg="3" md="4">
                  <v-text-field
                    v-model="localSearch"
                    class="rounded-lg"
                    clearable
                    dense
                    @click:clear="applyClearSearch"
                    label="جستجو"
                    outlined
                    @keydown.enter="applySearch"
                  >
                    <template v-slot:append>
                      <v-icon @click="applySearch" class="cursor-pointer" color="primary">
                        mdi-magnify
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-slot:index="{ item }">
              {{ item.index + 1 + (data.current_page - 1) * data.per_page }}
            </template>

            <template v-slot:user="{ item }">
              {{ item.user.name + ' ' + item.user.lastName }}
            </template>

            <template v-slot:payment_amount="{ item }">
              {{ persian(price(item.payment_amount)) }} ﷼
            </template>

            <template v-slot:available_at="{ item }">
              <div
                :style="{ backgroundColor: availableColor(item) }"
                :title="item.available_at_p"
                class="badge text-white text-white"
              >
                {{ secondToHuman(item.available_at) }}
              </div>
            </template>

            <template v-slot:deleted_at="{ item }">
              <div
                :id="item.id"
                :class="`badge-${item.deleted_at !== null ? 'success' : 'danger'}`"
                class="badge cursor-pointer"
                @click="payTask(item.id)"
              >
                {{ item.deleted_at != null ? 'پرداخت شده' : 'منتظر پرداخت' }}
              </div>
            </template>

            <template v-slot:action="{ item }">
              <manage-button :data="item" :meta="metaButtons" />
            </template>
          </vue-table>

          <!--            <mixed-table :columns="columns" :data="data" :fetch-data="getDataForTable" :reload-table="reloadTable"-->
          <!--                         :tbProps="tableProps"/>-->

          <p class="pa-2">
            جمع مبلغ پرداختی کل جدول:
            <strong>{{ totalAmount }}</strong> ﷼
          </p>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <service-monitoring />
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="moreInformation" max-width="600" transition="dialog-bottom-transition">
      <template>
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>اطلاعات بیشتر</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark icon @click="moreInformation = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <div class="pa-12">
              <div class="py-2 border-bottom my-2">
                <p class="d-block text-dark" style="font-size: 10pt">عنوان آگهی :</p>
                <p class="mr-3" style="font-size: 9pt">
                  {{ adsInformation['title'] }}
                </p>
              </div>
              <div class="py-2 border-bottom my-2">
                <p class="d-block text-dark" style="font-size: 10pt">توضیحات آگهی :</p>
                <p class="mr-3" style="font-size: 9pt">
                  {{ adsInformation['description'] }}
                </p>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>

    <custom-popup
      v-model="cafeBazarList"
      :cons="{ title: 'کافه بازار' }"
      hide-confirm
      max-width="1200"
      reloadable
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-text>
          <Bazar v-if="cafeBazarList" />
        </v-card-text>
      </v-card>
    </custom-popup>

    <custom-popup
      v-model="walletHistoryDialog"
      :cons="{ title: 'تاریخچه کیف پول' }"
      :max-width="1200"
    >
      <wallet-history :search="walletHistory" />
    </custom-popup>
  </v-card>
</template>

<script>
import { Axios2, echo } from '@/main';
import manageButton from '@/view/pages/button';
import TitleRibbon from '@/view/pages/uiBeautifier/titleRibbon';
import Setting from '@/view/pages/setting';
import { debounce } from '../../../custom';
import TransActionList from '@/view/pages/monitoring/transActionList';
import Vue from 'vue';
import CustomPopup from '@/core/plugins/TitleRibbon/plugins/popup/customPopup';
import WalletHistory from '@/view/pages/WalletHistory';
import FiltersTable from '@/components/Table/filtersTable';
import ServiceMonitoring from './serviceMonitoring.vue';
import PriceInput from '../uiBeautifier/priceInput';
import MixedTable from '../../../components/Table/MixedTable.vue';
import Bazar from '@/view/pages/monitoring/Bazar.vue';

export default {
  name: 'payMonitotoring',
  components: {
    Bazar,
    MixedTable,
    PriceInput,
    ServiceMonitoring,
    FiltersTable,
    WalletHistory,
    CustomPopup,
    TransActionList,
    Setting,
    TitleRibbon,
    manageButton,
  },
  data() {
    return {
      walletHistoryDialog: false,
      serverTime: {},
      tab: 0,
      data: {},
      headers: [
        { value: 'index', text: 'ردیف', align: 'center', sortable: false },
        { value: 'id', text: 'شناسه', align: 'center', sortable: false },
        { value: 'user', text: 'کاربر', align: 'center', sortable: false },
        {
          value: 'advertise_id',
          text: 'آگهی',
          align: 'center',
          sortable: false,
        },
        {
          value: 'payment_amount',
          text: 'قیمت',
          align: 'center',
          sortable: false,
        },
        {
          value: 'payment_title',
          text: 'نوع ارتقا',
          align: 'center',
          sortable: false,
        },
        {
          value: 'created_at_p',
          text: 'تاریخ ثبت',
          align: 'center',
          sortable: false,
        },
        {
          value: 'available_at',
          text: 'تاریخ ارسال',
          align: 'center',
          sortable: false,
        },
        {
          value: 'deleted_at',
          text: 'وضعیت پرداخت',
          align: 'center',
          sortable: false,
        },
        {
          value: 'order_id',
          text: 'توکن پرداخت',
          align: 'center',
          sortable: false,
        },
        { value: 'action', text: 'مدیریت', align: 'center', sortable: false },
      ],
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
        page: 1,
      },
      selectedRows: [],
      metaButtons: {
        permission_prefix: 'notification_',
        buttons: [
          {
            name: 'cafepay',
            label: 'کافه‌پی',
            icon: 'fa fa-shopping-basket',
            class: 'btn-outline-success',
            action: this.actions,
            status: 'admin_monitor_payment_get_link',
            condition(status) {
              return true;
            },
          },
          {
            name: 'refund',
            label: 'بازگشت وجه',
            icon: 'recycle',
            class: 'btn-outline-primary',
            action: this.actions,
            status: 'admin_monitor_payment_refund',
            condition(status) {
              return true;
            },
          },
          {
            name: 'pay',
            label: 'پرداخت',
            icon: 'dollar-sign',
            class: 'btn-outline-success',
            action: this.actions,
            status: 'admin_monitor_payment_get_link',
            condition(status) {
              return true;
            },
          },
          {
            name: 'token',
            label: 'مشاهده توکن',
            link: 'login',
            icon: 'eye',
            class: 'btn-outline-warning',
            action: this.actions,
            status: 'divar_update',
            condition(status) {
              return true;
            },
          },
          {
            name: 'myAds',
            label: 'آگهی من در دیوار',
            link: 'advertise_url',
            icon: 'sticky-note',
            class: 'btn-outline-info',
            action: this.actions,
            status: 'divar_update',
            condition(status) {
              return true;
            },
          },
          {
            name: 'moreInfo',
            label: 'اطلاعات بیشتر',
            icon: 'info-circle',
            class: 'btn-outline-primary',
            action: this.actions,
            status: 'divar_update',
            condition(status) {
              return true;
            },
          },
          {
            name: 'walletHistory',
            label: 'تاریخچه کیف پول',
            icon: 'wallet',
            class: 'btn-outline-primary',
            action: this.actions,
            status: 'divar_update',
            condition(status) {
              return true;
            },
          },
        ],
      },
      url: `${url}/admin/monitoring/payment`,
      urlService: `${url}/admin/monitoring/service`,
      timer: null,
      moreInformation: false,
      cafeBazarList: false,
      loading: false,
      adsInformation: {},
      walletHistory: {},
      searchBox: {
        search: '',
        length: 10,
      },
      openCafeCharge: false,
      cafeChargeAmount: 0,
      cons: {
        title: 'وارد کردن مبلغ',
      },
    };
  },
  mounted() {
    this.getDataForTable();

    this.timer = setInterval(() => {
      if (this.data && this.data.data) {
        this.data.data.map(x => {
          if (!x.new_available_at) x.new_available_at = x.available_at;

          x.available_at = x.new_available_at - this.serverTime.time_stamp;
        });
      }

      this.serverTime.time_stamp++;
    }, 1000);

    this.serverTime = window.Vue.getClock();

    echo.channel('advertise.payment').listen('.request', data => {
      let color = this.availableColor(data);

      if (color !== '#fb9678') return;

      this.data.data = [data, ...this.data.data.filter(x => x.id !== data.id)];
    });

    echo.channel('advertise.payment').listen('.delete', data => {
      this.data.data = this.data.data.filter(x => x.id !== data.id);
    });
  },
  computed: {
    totalAmount() {
      if (!this.data.data) return 0;

      return this.data.data
        .reduce((a, b) => {
          return a + b.payment_amount;
        }, 0)
        .toLocaleString();
    },
  },
  watch: {
    localSearch(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tableProps.search = newVal ? newVal.trim() : '';
        this.tableProps.page = 1;
        this.getDataForTable(this.url, this.tableProps);
      }
    },

    searchBox: {
      handler() {
        this.tableProps.length = this.searchBox.length;
      },
      deep: true,
    },
    tab() {
      if (this.tab == 0) this.getDataForTable(this.url, this.tableProps);
    },
  },
  methods: {
    applyClearSearch() {
      this.localSearch = '';
      this.tableProps.search = '';
      this.tableProps.page = 1;
      this.getDataForTable(this.url, this.tableProps);
    },
    applySearch() {
      this.tableProps.search = this.localSearch.trim() || '';
      this.tableProps.page = 1;
      this.getDataForTable(this.url, this.tableProps);
    },
    getNewData: function () {
      this.$nextTick(function () {
        this.$modal.showLoading();
      });
      this.tableProps.page = 1;
      this.getDataForTable(this.url, this.tableProps);

      setTimeout(() => {
        this.$nextTick(function () {
          this.$modal.hideLoading();
        });
      }, 3000);
    },
    buttonsCondition(status) {
      return status === '';
    },
    getDataForTable(url = this.url, query = this.tableProps) {
      const vm = this;
      vm.loading = true;
      $.ajax({
        url: url,
        type: 'GET',
        fn: this.getDataForTable,
        data: query,
        params: [url, query],
        headers: {
          ACCEPT: 'application/json',
          Authorization: Token,
        },
        success: function (data) {
          vm.data = data.data;
          vm.loading = false;
        },
      });
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.getDataForTable(this.url, props);
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.getDataForTable(this.url, tableProps);
      }, 1000);
    },
    cafeCharge() {
      Axios2.get(`admin/bazaar/charge?amount=${this.cafeChargeAmount}&phone=09174811484`).then(
        res => {
          if (res.data.data.detail) {
            Vue.$toast.error(res.data.data.detail, {
              position: 'top',
            });
          } else window.open(res.data.data.redirectUrl, '_blank');
        }
      );
    },
    async actions(data, type) {
      if (type === 'pay') {
        $.ajax({
          url: `${url}/admin/monitoring/payment/${data.id}`,
          type: 'GET',
          reload_table: this.reloadTable,
          fn: this.actions,
          params: [data, type],
          headers: {
            ACCEPT: 'application/json',
            Authorization: Token,
          },
          success: function (val) {
            window.open(val.data.payment_url, '_blank');
          },
        });
      } else if (type === 'token') {
        $.ajax({
          url: `${url}/admin/fresh`,
          type: 'POST',
          data: JSON.stringify({ token: data.login.split('=')[1] }),
          headers: {
            ACCEPT: 'application/json',
            Authorization: Token,
            'Content-Type': 'application/json',
          },
          msg: false,
          success() {
            window.open(data.login, '_blank');
          },
        });
      } else if (type === 'myAds') {
        window.open(data.advertise_url, '_blank');
      }
      if (type === 'refund') {
        try {
          const confirm = await this.$modal.yesNo(
            'بازگشت وجه',
            'پس از بازگشت وجه مجدد درخواست پرداخت داده شود؟',
            'neg',
            ''
          );

          if (confirm !== true && confirm !== false) {
            return;
          }

          $.ajax({
            url: `${url}/admin/monitoring/payment/refund/${data.id}`,
            method: 'PUT',
            data: { return: confirm },
            headers: {
              ACCEPT: 'application/json',
              Authorization: Token,
            },
            msg: true,
            success: () => {
              this.getDataForTable();
            },
            error: xhr => {
              console.error('Refund API failed:', xhr);
              this.$modal.alert('خطایی در انجام عملیات رخ داد. لطفا دوباره تلاش کنید.');
            },
          });
        } catch (e) {
          console.log('Modal closed by user or error:', e);
        }
      } else if (type === 'moreInfo') {
        this.moreInformation = true;
        this.adsInformation['title'] = data.advertise_title;
        this.adsInformation['description'] = data.advertise_description;
      } else if (type === 'cafepay') {
        $.ajax({
          url: `${url}/admin/monitoring/payment/${data.id}/bazaar`,
          type: 'GET',
          // reload_table: this.reloadTable,
          fn: this.actions,
          params: [data, type],
          headers: {
            ACCEPT: 'application/json',
            Authorization: Token,
          },
          success: () => {
            // this.reloadTable();
          },
        });
      } else if (type === 'walletHistory') {
        let date = data.created_at.split(' ')[0];
        let userId = data.user.id;

        this.walletHistory = {
          user: userId,
          date: date,
        };
        this.walletHistoryDialog = true;
      }
    },
    availableColor(item) {
      let color = '';

      if (item.deleted_at) {
        color = '#93a6f7';
      } else if (item.available_at > 0 && !item.deleted_at) {
        color = '#f81048';
      } else if (item.available_at < 0 && !item.deleted_at) color = '#fb9678';

      return color;
    },
    secondToHuman(second) {
      const suffix = second > 0 ? ' دیگر ' : ' پیش ';

      let str = '';

      second = Math.abs(Number(second));
      let day = Math.floor(second / 86400);
      let hour = Math.floor((second % 86400) / 3600);
      let minutes = Math.floor((second % 3600) / 60);
      second = Math.floor((second % 3600) % 60);

      if (!!day) str += `${Math.abs(day)} روز و `;
      if (!!hour) str += `${Math.abs(hour)} ساعت و `;
      if (!!minutes) str += `${Math.abs(minutes).toString().padStart(2, '0')} دقیقه و `;

      str += `${Math.abs(second).toString().padStart(2, '0')} ثانیه`;

      return `${str} ${suffix}`;
    },
    async payTask(id) {
      try {
        const value = await this.$modal.yesNo(
          'تایید پرداخت',
          'آیا از پرداخت این آگهی اطمینان دارید؟',
          'neg',
          ''
        );

        if (value === true) {
          $.ajax({
            url: `${url}/admin/monitoring/payment/${id}`,
            method: 'DELETE',
            fn: this.payTask,
            reload_table: this.reloadTable,
            headers: {
              ACCEPT: 'application/json',
              Authorization: Token,
            },
            msg: true,
            success: val => {
              this.getDataForTable();
            },
          });
        }
      } catch (e) {
        console.error('خطا در مودال', e);
      }
    },
  },
};
</script>

<style scoped></style>
